import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { SupportingDocumentsService } from '../../../services'
import { saveSupportingDocumentsOfType } from '../../../actions/supportingDocumentsActions';
import { startFetch, endFetch } from '../../../actions/generalActions';
import DocumentCard from './DocumentCard';

class SupportingDocumentsContent extends Component{

  constructor(props){
    super(props);
    this.state={
      user: this.props.user,
    };
  }

  componentDidMount() {
    this.getSupportingDocumentsOfType(this.props.match.params.slug);
  }

  componentDidUpdate(oldprops) {
    if (this.props.match.params.slug != oldprops.match.params.slug) {
      this.getSupportingDocumentsOfType(this.props.match.params.slug);
    }
  }

  getSupportingDocumentsOfType(typeId) {
    const payload = {
      client_slug: this.state.user.client.slug
    }
    this.props.startFetch()
    SupportingDocumentsService.getSupportingDocumentsOfType(payload, typeId)
      .then(response => {
        const supportingDocumentsOfType = response.data
        this.props.saveSupportingDocumentsOfType(supportingDocumentsOfType)
        this.props.endFetch()
      })
      .catch(()=>(this.props.endFetch()));
  }


  render(){
    const {
      campaign,
      user,
      campaignUser,
      supportingDocumentsOfType
    } = this.props
    return(
      <div className="document-container">
        {supportingDocumentsOfType.map((item,i) =>
        (
          <DocumentCard
            key={i}
            campaignUser={campaignUser}
            campaign={campaign}
            i={i}
            item={item}
            user={user}
          />
        ))}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.userReducer.user,
    campaign: state.campaignReducer.campaign,
    campaignUser: state.balanceReducer.campaignUser,
    supportingDocumentsOfType: state.supportingDocumentsReducer.supportingDocumentsOfType
  }
}

function mapDispatchToProps(dispatch){
  return{
    saveSupportingDocumentsOfType: (supportingDocuments, documentId) => {
      dispatch(saveSupportingDocumentsOfType(supportingDocuments, documentId));
    },
    startFetch: () => { dispatch(startFetch())},
    endFetch: () => { dispatch(endFetch())},
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SupportingDocumentsContent));
